import { render } from "./oneColumnTemplate.vue?vue&type=template&id=54ad1c26&scoped=true"
import script from "./oneColumnTemplate.vue?vue&type=script&lang=js"
export * from "./oneColumnTemplate.vue?vue&type=script&lang=js"

import "./oneColumnTemplate.vue?vue&type=style&index=0&id=54ad1c26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ad1c26"]])

export default __exports__